export class LoqateConfig {
    public static readonly BaseFindUrl: string = "https://services.postcodeanywhere.co.uk/Capture/Interactive/Find/v1.10/json3ex.ws?";
    public static readonly BaseRetrieveUrl: string = "https://services.postcodeanywhere.co.uk/Capture/Interactive/Retrieve/v1.10/json3ex.ws?";
    public static readonly Address: string = "Address";
    public static readonly Language: string = "en-gb";
    public static readonly Countries: string = "GBR";
    public static readonly Limit: number = 100;

    public static isAnAddress = (type: string): boolean => {
        return type === LoqateConfig.Address;
    }

    public static formatDescription = (description: string): string => {
        const formattedDescription = description.split(", ").join("\n");
        return formattedDescription;
    }
}
